/* eslint-disable */
import React from "react"
import "./styles.scss"

const SelectPeriod = ({ value, onChange }) => {
    return <div className="popups-select-period-container">
    </div>
}

export default SelectPeriod